// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"0c050c755c89d74df245","293":"c1fbe7807e17182a0f38","522":"1d459132782535bae72c"}[chunkId] + ".js";
};